module.exports = __webpack_public_path__ + "static/sotinaplus-89a65bbe6c8a6ed52cc83e9cd7cbf34d.jpg";